import React from "react"
import Image from "gatsby-image"
import { Typography, Grid, Box, makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    marginBottom: theme.spacing(4),
  },
  text: {
    fontSize: 18,
    lineHeight: "24px",
  },
}))

const Feature = ({ title, text, image }) => {
  const classes = useStyles()
  return (
    <Box marginBottom={4}>
      <Typography className={classes.title} variant="h2" align="center">
        {title}
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={image ? 6 : 12}>
          <Typography className={classes.text}>{text}</Typography>
        </Grid>
        {image && (
          <Grid item xs={12} sm={6}>
            <Image />
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default Feature
